import {
  SET_EMERGENCY_MESSAGE_REQUEST,
  SET_EMERGENCY_MESSAGE_SUCCESS,
  RESET_EMERGENCY_MESSAGE,
  SHOW_NOT_ONBOARDED_STATUS_MODAL_VISIBLE,
  HIDE_NOT_ONBOARDED_STATUS_MODAL_VISIBLE,
  SHOW_NOT_ONBOARDED_STATUS_BAR_VISIBLE,
  HIDE_NOT_ONBOARDED_STATUS_BAR_VISIBLE,
  SHOW_ORDER_CANCEL_SUCCESS_MODAL_VISIBLE,
  HIDE_ORDER_CANCEL_SUCCESS_MODAL_VISIBLE,
  SET_UPDATE_GROUP_BUY_CUSTOMERS_LIST,
  RESET_UPDATE_GROUP_BUY_CUSTOMERS_LIST,
  SET_HOME_MOUNTED,
  SET_HOME_UNMOUNTED,
  RESET_ONBOARDED_APP,
  SET_ONBOARDED_APP,
  SET_SHOULD_SHOW_SUPPORT_MODAL_VISIBLE,
  RESET_SHOULD_SHOW_SUPPORT_MODAL_VISIBLE,
  PAUSE_ALL_VIDEO_BANNERS,
  REFETCH_ORDER_DETAILS,
  SET_CAN_OPEN_HTTP_URLS,
  HYDRATE_VIEWED_STORES,
  UPDATE_VIEWED_STORIES,
  CLEAR_VIEWED_STORIES,
  SHOW_SETTINGS_MODAL,
  HIDE_SETTINGS_MODAL,
} from "./actionTypes";

export const actions = {
  setEmergencyMessageRequest: () => ({
    type: SET_EMERGENCY_MESSAGE_REQUEST,
  }),
  resetEmergencyMessage: () => ({
    type: RESET_EMERGENCY_MESSAGE,
  }),
  showNotOnboardedModalVisible: () => ({
    type: SHOW_NOT_ONBOARDED_STATUS_MODAL_VISIBLE,
  }),
  hideNotOnboardedModalVisible: () => ({
    type: HIDE_NOT_ONBOARDED_STATUS_MODAL_VISIBLE,
  }),
  showNotOnboardedStatusBarVisible: () => ({
    type: SHOW_NOT_ONBOARDED_STATUS_BAR_VISIBLE,
  }),
  hideNotOnboardedStatusbarVisible: () => ({
    type: HIDE_NOT_ONBOARDED_STATUS_BAR_VISIBLE,
  }),
  showOrderCancelSuccessModal: () => ({
    type: SHOW_ORDER_CANCEL_SUCCESS_MODAL_VISIBLE,
  }),
  hideOrderCancelSuccessModal: () => ({
    type: HIDE_ORDER_CANCEL_SUCCESS_MODAL_VISIBLE,
  }),
  setUpdateCustomersList: () => ({
    type: SET_UPDATE_GROUP_BUY_CUSTOMERS_LIST,
  }),
  resetUpdateCustomersList: () => ({
    type: RESET_UPDATE_GROUP_BUY_CUSTOMERS_LIST,
  }),
  setHomeMounted: () => ({
    type: SET_HOME_MOUNTED,
  }),
  setHomeUnMounted: () => ({
    type: SET_HOME_UNMOUNTED,
  }),
  pauseAllVideoBanners: () => ({
    type: PAUSE_ALL_VIDEO_BANNERS,
  }),
  refetchOrderDetails: () => ({
    type: REFETCH_ORDER_DETAILS,
  }),
  setCanOpenHttpUrls: () => ({
    type: SET_CAN_OPEN_HTTP_URLS,
  }),
  hydrateViewedStories: () => ({ type: HYDRATE_VIEWED_STORES }),
  updateViewedStories: (payload) => ({
    type: UPDATE_VIEWED_STORIES,
    payload,
  }),
  clearViewedStories: (payload) => ({
    type: CLEAR_VIEWED_STORIES,
  }),
  showSettingsModal: () => ({
    type: SHOW_SETTINGS_MODAL,
  }),
  hideSettingsModal: () => ({
    type: HIDE_SETTINGS_MODAL,
  }),
  setShowLocationSearch: (value) => ({
    type: "SET_LOCATION_SEARCH",
    payload: value,
  }),
  setAskLocationInside: (value) => ({
    type: "ASK_LOCATION_INSIDE",
    payload: value,
  }),
};

const initialState = {
  title: "",
  description: "",
  image: "",
  type: "",
  notOnboardedModalVisible: false,
  notOnboardedStatusBarVisible: true,
  orderCancelSuccessModalVisible: false,
  updateCustomersList: false,
  homeMounted: false,
  navigatToAuthLoading: false,
  pauseAllVideoBanners: false,
  toggleOrderDetailsRefetch: false,
  canOpenHttpUrls: false,
  viewedStories: [],
  settingsModal: false,
  showLocationSearch: false,
  askLocationInside: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EMERGENCY_MESSAGE_SUCCESS:
      const {
        title = "",
        description = "",
        image = "",
        type = "",
      } = action.payload;

      return {
        ...state,
        title,
        description,
        image,
        type,
      };

    case RESET_EMERGENCY_MESSAGE:
      return {
        ...state,
        title: "",
        description: "",
        image: "",
        type: "",
      };

    case SHOW_NOT_ONBOARDED_STATUS_MODAL_VISIBLE:
      return {
        ...state,
        notOnboardedModalVisible: true,
      };

    case HIDE_NOT_ONBOARDED_STATUS_MODAL_VISIBLE:
      return {
        ...state,
        notOnboardedModalVisible: false,
      };

    case SHOW_NOT_ONBOARDED_STATUS_BAR_VISIBLE:
      return {
        ...state,
        notOnboardedStatusBarVisible: true,
      };

    case HIDE_NOT_ONBOARDED_STATUS_BAR_VISIBLE:
      return {
        ...state,
        notOnboardedStatusBarVisible: false,
      };

    case SHOW_ORDER_CANCEL_SUCCESS_MODAL_VISIBLE:
      return {
        ...state,
        orderCancelSuccessModalVisible: true,
      };

    case HIDE_ORDER_CANCEL_SUCCESS_MODAL_VISIBLE:
      return {
        ...state,
        orderCancelSuccessModalVisible: false,
      };

    case SET_UPDATE_GROUP_BUY_CUSTOMERS_LIST:
      return {
        ...state,
        updateCustomersList: true,
      };

    case RESET_UPDATE_GROUP_BUY_CUSTOMERS_LIST:
      return {
        ...state,
        updateCustomersList: false,
      };

    case SET_HOME_MOUNTED:
      return {
        ...state,
        homeMounted: true,
      };
    case SET_HOME_UNMOUNTED:
      return {
        ...state,
        homeMounted: false,
      };
    case PAUSE_ALL_VIDEO_BANNERS:
      return {
        ...state,
        pauseAllVideoBanners: !state.pauseAllVideoBanners,
      };
    case REFETCH_ORDER_DETAILS:
      return {
        ...state,
        toggleOrderDetailsRefetch: !state.toggleOrderDetailsRefetch,
      };
    case SET_CAN_OPEN_HTTP_URLS:
      return {
        ...state,
        canOpenHttpUrls: true,
      };
    case UPDATE_VIEWED_STORIES:
      return {
        ...state,
        viewedStories: [
          ...new Set([...state.viewedStories, ...action.payload]),
        ],
      };
    case CLEAR_VIEWED_STORIES:
      return {
        ...state,
        viewedStories: [],
      };
    case SHOW_SETTINGS_MODAL:
      return {
        ...state,
        settingsModal: true,
      };
    case HIDE_SETTINGS_MODAL:
      return {
        ...state,
        settingsModal: false,
      };
    case "SET_LOCATION_SEARCH":
      return {
        ...state,
        showLocationSearch:
          action.payload === true || action.payload === false
            ? action.payload
            : false,
      };

    case "ASK_LOCATION_INSIDE":
      return {
        ...state,
        askLocationInside:
          action.payload === true || action.payload === false
            ? action.payload
            : true,
      };
  }
  return state;
};

reducer.initialState = initialState;

export default reducer;
